/******************************************************************************************** */
// UPDATE MAIN IMAGE WHEN THUMBNAIL IS CLICKED
const productMainImage = document.querySelector(
  ".main-image .slide--custom-initial .product-media img"
);
const thumbnails = document.querySelectorAll(".thumbnails a.thumbnail");

// Add a click event listener to each thumbnail
thumbnails.forEach(function (thumbnail) {
  thumbnail.addEventListener("click", function (event) {
    // Prevent the default link action
    event.preventDefault();

    // Get the new image URL from the thumbnail's href
    var newSrc = this.getAttribute("href");

    if (productMainImage) {
      // Update the main image's src attribute
      productMainImage.setAttribute("src", newSrc);
    }

    // Get the thumbnail's <img> element to update srcset and alt
    var thumbImg = this.querySelector("img");
    if (thumbImg && productMainImage) {
      // If the thumbnail has a data-srcset attribute, update the main image's srcset
      var newSrcset = thumbImg.getAttribute("data-srcset");
      if (newSrcset) {
        productMainImage.setAttribute("srcset", newSrcset);
      }

      // Update the main image's alt attribute with the thumbnail's alt
      var newAlt = thumbImg.getAttribute("alt");
      if (newAlt) {
        productMainImage.setAttribute("alt", newAlt);
      }
    }
  });
});
/******************************************************************************************** */

/******************************************************************************************** */
// UPDATE URL ON VARIANT CHANGE
const radioOptions = document.querySelectorAll(
  '.opt-btn.js-option[type="radio"]'
);

// Add event listener to each radio button
radioOptions.forEach((radio) => {
  radio.addEventListener("change", () => {
    if (radio.checked) {
      const selectedOption = radio.value;

      // Find matching variant ID from productVariants
      const variant = productVariants.find((variant) => {
        return variant.option1 === selectedOption;
      });

      const variantId = variant.id; // Get variant ID
      const url = new URL(window.location.href);

      url.searchParams.set("variant", variantId); // Update 'variant' parameter in URL

      // Reload page with updated URL
      window.location.href = url.toString();
    }
  });
});
/******************************************************************************************** */

/******************************************************************************************** */
// Populate product specifications (product-level custom metafields)
document.addEventListener("DOMContentLoaded", () => {
  if (typeof productSpecs === "undefined") return;

  const formatSpecText = (value) => {
    if (value === null || value === undefined) return "-";

    if (typeof value === "string") {
      const trimmed = value.trim();
      return trimmed !== "" ? value : "-";
    }

    if (typeof value === "object") {
      if (typeof value.value === "string") {
        return formatSpecText(value.value);
      }

      if (Array.isArray(value)) {
        const lines = value
          .map((item) => formatSpecText(item))
          .filter((line) => line !== "-");
        return lines.length ? lines.join("\n") : "-";
      }

      if (value.type === "root" && Array.isArray(value.children)) {
        const richText = extractRichText(value.children).trim();
        return richText !== "" ? richText : "-";
      }
    }

    return "-";
  };

  const extractRichText = (nodes) =>
    nodes
      .map((node) => {
        if (!node || typeof node !== "object") return "";

        if (node.type === "text" && node.value) return node.value;
        if (node.type === "paragraph" && Array.isArray(node.children)) {
          return extractRichText(node.children);
        }
        if (Array.isArray(node.children)) return extractRichText(node.children);

        return "";
      })
      .join("\n")
      .replace(/\n{3,}/g, "\n\n");

  const specsData = [
    formatSpecText(productSpecs.material),
    formatSpecText(productSpecs.size),
    formatSpecText(productSpecs.weight),
    formatSpecText(productSpecs.technology),
    formatSpecText(productSpecs.particularities),
    formatSpecText(productSpecs.quality),
    formatSpecText(productSpecs.type_of_usage),
    formatSpecText(productSpecs.user_manual),
    formatSpecText(productSpecs.storage_instructions),
  ];

  document
    .querySelectorAll(".specification__value[data-spec-value]")
    .forEach((valueElement, index) => {
      if (specsData[index] !== undefined) {
        valueElement.textContent = specsData[index];
      }
    });
});
/******************************************************************************************** */
